import { useEffect, useState, useRef, useCallback } from "react";
import { useSearch } from "../context/SearchContext";
import { getPosts } from "../services/api";
import PostItem from "../components/posts/PostItem";
import { useTranslation } from "react-i18next";
import { searchPosts } from "../services/api";

const SearchResultsPage = () => {
  const { t } = useTranslation();
  const { query } = useSearch();
  const [results, setResults] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const limit = 5;

  const observer = useRef();

  const lastResultRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setOffset((prev) => prev + limit);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  useEffect(() => {
    setResults([]);
    setOffset(0);
    setHasMore(true);
  }, [query]);

useEffect(() => {
  const fetchResults = async () => {
    setLoading(true);
    try {
      // ✅ ya mandamos search al backend
      const res = await searchPosts({ limit, offset, search: query });
      const allPosts = res.data.results || [];

      setResults((prevResults) => {
        const combined = [...prevResults, ...allPosts];
        return Array.from(new Map(combined.map((p) => [p.id, p])).values());
      });

      setHasMore(res.data.next !== null);
    } catch (err) {
      console.error("Error al buscar posts", err);
    } finally {
      setLoading(false);
    }
  };

  if (query.trim()) {
    fetchResults();
  }
}, [offset, query]);


  return (
    <div className="max-w-3xl mx-auto px-4 pt-2 md:pt-[80px]">

      {results.length === 0 && !loading && (
        <p style={{ color: "#888" }}>{t("search_results.empty", "No se encontraron resultados.")}</p>
      )}

      {results.map((post, i) => (
        <div key={post.id} ref={i === results.length - 1 ? lastResultRef : null}
        className={`pb-2 ${i !== results.length - 1 }`}
        >
          <PostItem post={post} />
        </div>
      ))}

      {loading && <div style={styles.loading}>{t("search_results.loading", "Cargando más resultados...")}</div>}

    </div>
  );
};

const styles = {
  container: {
    maxWidth: "600px",
    margin: "0 auto",
    padding: "20px",
  },
  loading: {
    textAlign: "center",
    padding: "15px",
    color: "#666",
  },
};

export default SearchResultsPage;
